<template>
  <div class="m-uploader">
    <ul class="file-list" v-if="type === 'many'">
      <li
        class="file-item"
        v-for="(item, index) in list"
        :key="item.uid"
        @focus="onFocus"
        @mouseenter="onHover(index)"
        @mouseleave="onMouseLeave()"
        v-dragging="{ list: list, item: item, group: 'item' }"
      >
        <img class="file-img" :src="item.url" />
        <div class="edit-mask" v-if="editIndex === index">
          <span class="el-upload-list__item-actions">
            <span
              class="el-upload-list__item-preview"
              @click="handlePictureCardPreview(item)"
            >
              <i class="el-icon-zoom-in" v-if="getFileTypeByExtension(item.url) == 'image'"></i>
              <i class="el-icon-video-play" v-else></i>
            </span>
            <i
              class="el-icon-delete"
              style="color: #fff; margin-left: 10px"
              @click="handleRemove(item)"
            ></i>
          </span>
        </div>
      </li>
    </ul>
    <ul class="file-list" v-else>
      <li
        class="file-item"
        @focus="onFocus"
        @mouseenter="onHover(0)"
        @mouseleave="onMouseLeave()"
        v-if="file"
      >
        <img class="file-img" :src="file" v-if="getFileTypeByExtension(file) == 'image'"/>
        <img class="file-img" src="https://oss.yf-gz.cn/file/1721632554997_f8ba0fea694d1c6a2a507f6af5a7f86b.png" v-if="getFileTypeByExtension(file) == 'audio'"/>
        <img class="file-img" src="https://oss.yf-gz.cn/file/1725611399884_eccae0741a94af7a2b5e8705ff7fab24.jfif" v-if="getFileTypeByExtension(file) == 'json'"/>
        <video :controls="false" width="100%" :src="file" alt="" v-if="getFileTypeByExtension(file) == 'video'" class="file-img" ref="veo"/>
        <div class="edit-mask" v-if="editIndex === 0">
          <span class="el-upload-list__item-actions">
            <span
              class="el-upload-list__item-preview"
              @click="handlePictureCardPreview({ url: file })"
            >
              <i class="el-icon-zoom-in" v-if="getFileTypeByExtension(file) == 'image' || getFileTypeByExtension(file) == 'json'"></i>
              <i class="el-icon-video-play" v-else></i>
            </span>
            <i
              class="el-icon-delete"
              style="color: #fff; margin-left: 10px"
              @click="handleRemove({ url: file })"
            ></i>
          </span>
        </div>
      </li>
    </ul>
    <el-upload
      ref="upload"
      :show-file-list="false"
      action="string"
      :file-list="type === 'single' ? (file ? [{ url: file }] : []) : fileList"
      :limit="limit"
      :on-preview="handlePictureCardPreview"
      :on-remove="handleRemove"
      :on-success="handleSuccess"
      :on-exceed="handleExceed"
      style="margin-bottom: 8px"
      :before-upload="beforeUpload"
      :on-error="handleError"
      :http-request="handleUploadFile"
      v-if="!(file && hideUploadHasFile && type === 'single')"
    >
      <!-- <i slot="default" class="el-icon-plus"></i> -->
      <div slot="default" class="uploader-default">
        <i class="el-icon-video-camera" v-if="fileType == 'video'"></i>
        <i class="el-icon-headset" v-if="fileType == 'audio'"></i>
        <i class="el-icon-picture-outline" v-if="fileType == 'image'"></i>
        <i class="el-icon-document" v-if="fileType == 'json'"></i>
        <span style="line-height: 22px;">{{ upName }}</span>
      </div>
      <div slot="tip" class="el-upload__tip" v-if="tip">{{ tip }}</div>
      <div slot="file" slot-scope="{ file }">
        <img
          class="el-upload-list__item-thumbnail"
          :src="file.url"
          v-if="getFileTypeByExtension(file.url) == 'image'"
        />
        <div style="position: relative" v-else>
          <el-tag type="success" style="position: absolute">视频</el-tag>
          <video
            :controls="true"
            class="el-upload-list__item-thumbnail"
            :src="file.url"
          ></video>
        </div>
        <span class="el-upload-list__item-actions">
          <span
            class="el-upload-list__item-preview"
            @click="handlePictureCardPreview(file)"
          >
            <i class="el-icon-zoom-in" v-if="getFileTypeByExtension(file.url) == 'image'"></i>
            <i class="el-icon-video-play" v-else></i>
          </span>
          <span class="el-upload-list__item-delete" @click="handleRemove(file)">
            <i class="el-icon-delete"></i>
          </span>
        </span>
      </div>
    </el-upload>
    <el-dialog :append-to-body="true"
      :visible.sync="dialogVisible"
      :width="getWidth(dialogImageUrl)"
      v-if="dialogVisible && getFileTypeByExtension(dialogImageUrl) == 'audio'"
    >
      <!-- <el-image
        style="width: 100%;max-height:70vh;"
        class="flexRowCenter"
        :src="dialogImageUrl"
        fit="contain"
        :preview-src-list="[dialogImageUrl]"
        v-if="getFileTypeByExtension(dialogImageUrl) == 'image'"
      ></el-image> -->
      <audio :controls="true" :src="dialogImageUrl" v-if="getFileTypeByExtension(dialogImageUrl) == 'audio'" style="width:100%" :autoplay="true"></audio>
      <!-- <video :controls="true" width="100%" :src="dialogImageUrl" alt="" v-if="getFileTypeByExtension(dialogImageUrl) == 'video'" style="max-height:70vh;"/> -->
    </el-dialog>

    <!-- 预览视频弹窗 -->
    <div class="subscribe_pop flexRowCenter" v-if="dialogVisible && getFileTypeByExtension(dialogImageUrl) != 'audio'" @click="dialogVisible = false">
      <div class="video_contain">
        <div class="video-play-close flexRowCenter" @click="dialogVisible = false">
          <img src="https://oss.yf-gz.cn/file/1721615290325_9c429ad8db74ef366c5407e639edb001.svg" alt="">
        </div>
        <img
          style="height:700px;object-fit: contain;"
          class="flexRowCenter"
          :src="dialogImageUrl"
          v-if="getFileTypeByExtension(dialogImageUrl) == 'image'"
          @click.stop=""
        >
        <video :controls="true" :src="dialogImageUrl" alt=""
          v-if="getFileTypeByExtension(dialogImageUrl) == 'video'"
          style="height:640px;width: 360px;object-fit: contain;z-index:202;display:block;" :autoplay="true" @click.stop=""
        />
        <pre v-if="getFileTypeByExtension(dialogImageUrl) == 'json'" class="json_block">
          {{JSON.stringify(jsonContent, null, 2)}}
        </pre>
      </div>
    </div>

    <canvas id="canvasElement" style="display:none;"></canvas>
  </div>
</template>

<script>

import * as uploadOss from '../common/uploadOss'

export default {
  props: {
    //多张图片的字段
    fileList: {
      type: Array,
      default() {
        return [];
      },
    },
    upName: {
      type: String,
      default: "上传图片",
    },
    //单张图片的字段
    file: {
      type: String,
      default: "",
    },
    fileType: {
      type: String,
      default: "image", //image图片，video视频
    },
    //图片类型，single单张，many多张
    type: {
      type: String,
      default: "many",
    },
    //上传限制数量，默认不限制
    limit: [Number, String],
    //提示
    tip: {
      type: String,
      default: "",
    },
    loading: {
      type: Boolean,
      default: false,
    },
    videoCoverUrl: {
      type: String,
      default: "",
    },
    videoDuration: {
      type: Number,
      default: "",
    },
    otherUploadUrl: {
      type: String,
      default: "",
    },
    hideUploadHasFile: { //单张上传，在有文件的情况下是否隐藏上传按钮
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      dialogImageUrl: "",
      dialogVisible: false,
      editIndex: "",
      list: [],
      isFirst: true,
      jsonContent: '',
    };
  },
  computed: {
    getFileTypeByExtension() {
      return function(filename) {
        console.log('filename',filename);
        const extension = filename.split('.').pop().toLowerCase();
        if (['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp'].includes(extension)) {
            return 'image';
        } else if (['mp4', 'webm', 'ogg', 'avi', 'mkv'].includes(extension)) {
            return 'video';
        } else if (['mp3', 'wav', 'aac', 'flac', 'm4a', 'ogg'].includes(extension)) {
            return 'audio';
        } else if (['json'].includes(extension)) {
            return 'json';
        }
        return 'image';
      }
    },
    getWidth() {
      return function(filename) {
        let type = this.getFileTypeByExtension(filename)
        if(type == 'image') {
          return '600px'
        } else if(type == 'video') {
          return '20%'
        } else if(type == 'audio') {
          return '20%'
        }
      }
    },
    uploadUrl() {
      return this.otherUploadUrl || this.$store.state.uploadUrl;
    },
    initFileList() {
      let list =
        this.type === "single"
          ? [{ url: this.file }]
          : JSON.parse(JSON.stringify(this.fileList));
      return list;
    }
  },
  mounted() {
    this.$dragging.$on("dragged", ({ value }) => {
      let list = JSON.parse(JSON.stringify(value.list));
      this.$emit("update:fileList", list);
    });
  },
  watch: {
    fileList: {
      immediate: true,
      handler: function (newVal, oldVal) {
        if (newVal.length > 0 && (!oldVal || oldVal.length === 0) && this.isFirst) {
          this.$nextTick(() => {
            this.list = this.$tools.deepClone(this.fileList);
          });
          this.isFirst = false;
        }
      },
    },
  },

  methods: {
    handleError(error, file, fileList) {
      this.$emit("update:loading", false);
    },
    handleProgress(event, file, fileList) {
      console.log('上传进度:', event.percent);
      // 如果需要根据进度条来控制 loading 状态，可以在这里进行调整
    },
    beforeUpload(file) {
      console.log(file)
      this.$emit("update:loading", true);
      // 在这里可以对文件做一些预处理，比如检查文件大小或类型
      return true; // 返回true则继续上传，否则终止上传
    },
    handleRemove(file, fileList) {
      if (this.type === "single") {
        this.$emit("update:file", "");
      } else {
        let list = JSON.parse(JSON.stringify(this.fileList));
        let index = list.findIndex((item) => item.url === file.url);
        list.splice(index, 1);
        this.list = this.$tools.deepClone(list);
        this.$emit("update:fileList", list);
      }
    },
    async fetchLocalJsonFile(filePath) {
      try {
        // 发起 HTTP 请求
        const response = await fetch(filePath);

        // 检查响应状态
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }

        // 解析 JSON 数据
        const data = await response.json();
        console.log(data);
        return data;
      } catch (error) {
        console.error('Error fetching JSON data:', error);
      }
    },
    async handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      if(this.fileType == 'json') {
        let jsonData = await this.fetchLocalJsonFile(file.url)
        // this.jsonContent = JSON.stringify(jsonData, null, 2)
        this.jsonContent = await this.fetchLocalJsonFile(file.url)
      }
      this.dialogVisible = true;
    },
    // 自定义上传
    handleUploadFile(option) {
      if (this.beforeUpload(option.file)) {
        //获取视频时长
        let url = URL.createObjectURL(option.file)
        let audioElement = new Audio(url)
        audioElement.addEventListener('loadedmetadata',  () =>{
          this.$emit("update:videoDuration", parseInt(audioElement.duration));
          console.log('badianboke视频时长为:', audioElement.duration);
        })
        this.$emit("update:loading", true);
        //获取文件后缀
        const lastDotIndex = option.file.name.lastIndexOf('.');
        const extension = lastDotIndex === -1 ? '' : option.file.name.substring(lastDotIndex + 1);
        //获取上传后的url
        const _name = `/file/${Date.now()}${option.file.uid}.${extension}`;
        uploadOss.put(_name, option.file).then((res) => {
          if (res) {
            uploadOss.getUrl(res.name).then((rel) => {
              // 返回oss地址，替换为https
              const ossUrl = rel.split('?')[0].replace("http:", "https:")
                .replace("zztea21.oss-cn-shenzhen.aliyuncs.com", "oss.yf-gz.cn")
              this.$emit("update:file", ossUrl);
              this.$emit("success", ossUrl);
              // 视频封面
              let src = ossUrl + `?x-oss-process=video/snapshot,t_1,f_png`
              this.$emit("update:videoCoverUrl", src);
              this.$emit('updateCoverUrl',src)
              this.$emit("update:loading", false);
              this.$refs.upload.clearFiles()
            })
          } else {
            this.$refs.upload.clearFiles()
            this.$message.error('上传失败！');
          }
        })
      }
    },
    // 取消上传
    handleCancel() {
      uploadOss.cancelUpload().then((rel) => {
        if (rel) {
          this.$refs.upload.abort()
          this.$emit("update:loading", false);
        }
      })
    },
    handleSuccess(response, file, fileList) {
      console.log('上传成功');
      this.$emit("update:loading", false);
      this.$emit("success", response.data);
      if (this.type === "single") {
        console.log('response.data',response);
        if(response.data && response.status == 1) {
          this.$emit("update:file", response.data);
        } else {
          this.$message.error(response.msg || '上传失败！');
        }

        //获取视频的封面图及时长
        if(this.fileType == 'video') {
          if(!this.videoCoverUrl) {
            // let src = response.data + `?x-oss-process=video/snapshot,t_1,f_jpg,m_fast,ar_auto`
            let src = response.data + `?x-oss-process=video/snapshot,t_1,f_png`
            this.$emit("update:videoCoverUrl", src);
            this.$emit('updateCoverUrl',src)
          }

          let url = URL.createObjectURL(file.raw)
          let audioElement = new Audio(url)
          audioElement.addEventListener('loadedmetadata',  () =>{
            this.$emit("update:videoDuration", parseInt(audioElement.duration));
            console.log('badianboke视频时长为:', audioElement.duration);
          })
        }
        // if(this.fileType == 'audio') {
        //   let url = URL.createObjectURL(file.raw)
        //   let audioElement = new Audio(url)
        //   audioElement.addEventListener('loadedmetadata',  () =>{
        //     this.$emit("update:audioDuration", parseInt(audioElement.duration));
        //     console.log('badianboke音频时长为:', audioElement.duration);
        //   })
        // }
      } else {
        let list = JSON.parse(JSON.stringify(this.fileList));
        list.push({
          url: response.data,
          status: 1,
        });
        this.list = this.$tools.deepClone(list);
        this.$emit("update:fileList", list);
      }
    },
    handleExceed(files, fileList) {
      this.$message.error(`图片限制最多上传${this.limit}张`);
    },
    onFocus(e) {
      console.log("聚焦", e);
    },
    onHover(index) {
      this.editIndex = index;
      console.log("拖拽");
    },
    onMouseLeave() {
      this.editIndex = "";
    },
  },
};
</script>

<style lang="less" scoped>
.m-uploader {
  display: flex;
  align-items: flex-start;
  flex-wrap: wrap;
}
.file-list {
  display: flex;
  align-items: center;
  .file-item {
    width: 80px;
    height: 80px;
    overflow: hidden;
    background-color: #fff;
    border: 1px solid #c0ccda;
    border-radius: 4px;
    box-sizing: border-box;
    margin: 0 8px 8px 0;
    display: inline-block;
    position: relative;
    .file-img {
      width: 100%;
      height: 100%;
      object-fit: contain;
      // object-position: top;
    }
  }
}

.edit-mask {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
}

.el-icon-zoom-in,
.el-icon-video-play {
  color: #fff;
}
.uploader-default {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 80px;
  height: 80px;
  border: 1px dashed #dddddd;
  border-radius: 4px;
  color: #666666;
}
.subscribe_pop {
  width: 100vw;
  height: 100vh;
  background: rgba(0,0,0,0.5);
  border-radius: 0rpx 0rpx 0rpx 0rpx;
  opacity: 1;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow: hidden;
  z-index: 201;
}
.video_contain {
  position: relative;
  border-radius:12px;
  overflow:hidden;
  .video-play-close {
    border-radius: 16px;
    width: 32px;
    height: 32px;
    color: #fff;
    font-size: 12px;
    top: 12px;
    right: 12px;
    position: absolute;
    z-index:203;
  }
}
.json_block {
  white-space: pre-line;
}
</style>



// WEBPACK FOOTER //
// src/zzcbpmDashboard/common/m-uploader2.vue